import React, { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    console.log("Pathname changed, scrolling to top:", pathname);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);
  // Show button when scrolled 200px
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="
            fixed bottom-6 right-6 z-9999 p-3 rounded-full 
            bg-[#004E92] text-white shadow-lg 
            hover:bg-[#003B73] transition-all 
            flex items-center justify-center
          "
        >
          <ChevronUp size={28} />
        </button>
      )}
    </div>
  );
};

export default ScrollToTop;
